<template>
    <div class="c-exam-room-wrap" v-if="examVisible">
        <template v-if="type !== 'popup'">
            <img class="bg" src="@/assets/vipGoods/201/12.png" alt="">
            <van-sticky  @scroll="scroll" class="van-sticky">
                <div :class="['video-wrap',fixed && 'top']">
                    <div class="video-header">
                        <div class="header-left" v-if="fixed"><img @click="goBack()" src="@/assets/public/icon_back.png" alt=""/></div>
                        <div class="title">{{videoInfo.cityName}}科目三考场</div>
                        <div class="btn-go-exam" @click="goAllExam">切换考场></div>
                        <div class="tips">如果不是你的考场，请点击切换</div>

                    </div>
                    <div class="video-category">
                        <div v-for="(v,i) in videoCategory" :class="[ v.examPlaceBatchId === examPlaceBatchId && 'active']" :key="i" @click="handleToggleVideoInfo(v)">{{v.examPlaceName}}{{v.id}}</div>
                    </div>
                    <div class="video-list">
                        <div class="video-item" v-for="(v,i) in videoInfo.videoList" :key="i" @click="goExamDetail(v)">
                            <img class="cover" :src="v.coverUrl" alt="">
                            <div class="mask">
                                <div class="exam-place-name">{{videoInfo.examPlaceName}}</div>
                                <div class="name">{{v.name}}</div>
                            </div>
                            <div class="play"><van-icon name="play-circle-o" /></div>
                            <span class="time">{{formatSeconds(v.duration)}}</span>
                        </div>
                    </div>
                </div>
            </van-sticky>
        </template>

        <van-popup v-model="examRoomVisible" position="bottom" class="exam-room-wrap">
            <div class="content-title">
                <div class="location">{{ cityName }}</div>
                <div class="text">请选择您的科三考场</div>
                <img @click="close" class="close" src="@/assets/vipGoods/icon_gb.png" alt="">
            </div>
            <div class="content">
                <div :class="['item',v.id === selectExamId && 'active']" v-for="(v,i) in videoCategoryAll" :key="i" @click="selectExamId = v.id">
                    <img class="photo" :src="v.reduceUrl" alt="">
                    <div class="info">
                        <div class="name">{{ v.name }}</div>
                        <div class="num">共<b>{{ v.count }}</b>条路线</div>
                    </div>
                </div>
            </div>
            <div class="popup-footer">
                <p class="msg">温馨提示：如您暂不知道您的考场，可选择任意一个考场购买，待确认考场后再联系斑斑客服，我们将为您提供一次免费更换考场服务。</p>
                <div :class="['submit',!selectExamId && 'disabled']" @click="submit">
                    确定
                </div>
            </div>
        </van-popup>
    </div>
</template>
<script>
import { Sticky, Icon, Popup, Toast } from 'vant'

export default {
    data () {
        return {
            cityName: '',
            examVisible: true,
            examRoomVisible: false,
            allExamFlag: false,
            examPlaceBatchId: '',
            videoCategory: [],
            videoCategoryAll: [],
            videoInfo: {},
            selectExamId: '',
            fixed: false
        }
    },
    props: ['goodsCode', 'initExamPlaceBatchId', 'type', 'cityCode'],
    components: {
        [Sticky.name]: Sticky,
        [Popup.name]: Popup,
        [Icon.name]: Icon
    },
    methods: {
        formatSeconds (s) {
            s = parseInt(s)
            // 计算分钟
            // 算法：将秒数除以60，然后下舍入，既得到分钟数
            let h
            h = Math.floor(s / 60)
            // 计算秒
            // 算法：取得秒%60的余数，既得到秒数
            s = s % 60
            // 将变量转换为字符串
            h += ''
            s += ''
            // 如果只有一位数，前面增加一个0
            h = (h.length === 1) ? '0' + h : h
            s = (s.length === 1) ? '0' + s : s
            return h + ':' + s
        },
        close () {
            this.examRoomVisible = false
            this.allExamFlag = false
            this.selectExamId = this.examPlaceBatchId
        },
        submit () {
            if (!this.allExamFlag) {
                this.$emit('submit', this.selectExamId)
            }
            this.handleToggleVideoInfo({ examPlaceBatchId: this.selectExamId })
            this.examRoomVisible = false
            this.allExamFlag = false
        },
        handleToggleVideoInfo (item) {
            if (this.examPlaceBatchId !== item.examPlaceBatchId) {
                this.examPlaceBatchId = item.examPlaceBatchId
                this.selectExamId = item.examPlaceBatchId
                this.goodsVideoList()
            }
        },
        // 返回
        goBack () {
            if (this.$route.query.back) {
                this.$router.back()
            } else {
                this.$jsBridge.callBackHandler('returnLastPage')
            }
        },
        // 获取未开通考场视频
        goodsVideoList () {
            let data = {
                subject: 3,
                examPlaceBatchId: this.examPlaceBatchId,
                cityCode: this.cityCode
            }
            Toast.loading({ duration: 0, overlay: true, message: '加载中...' })

            this.$api.goodsVideoList(data).then(res => {
                Toast.clear()
                if (res.status && res.result) {
                    const arr = res.result
                    if (arr.length === 0) {
                        this.examVisible = false
                    } else {
                        this.videoCategory = arr
                        if (!this.examPlaceBatchId) {
                            this.videoInfo = arr[0]
                            this.examPlaceBatchId = arr[0].examPlaceBatchId
                            this.selectExamId = this.examPlaceBatchId
                        } else {
                            this.videoInfo = arr.find(({ examPlaceBatchId }) => (examPlaceBatchId === this.examPlaceBatchId)) || {}
                        }
                    }
                } else {
                    this.examVisible = false
                }
            })
        },
        // 获取分类
        goodsVideoListAll () {
            this.$api.getExamPlaceList({
                subject: 3,
                cityCode: this.cityCode
            }).then(res => {
                if (res.status && res.result.examPlaceList) {
                    res.result.examPlaceList.find(v => {
                        // 考场视频存在表示当前的城市
                        if (v.examPlaceList && v.examPlaceList.length) {
                            this.videoCategoryAll = v.examPlaceList
                            this.cityName = v.cityName
                        }
                    })
                }
            })
        },
        // 跳转考场详情
        goExamDetail (v) {
            localStorage.setItem('t-c-goodsCode', this.goodsCode)
            this.$jsBridge.callBackHandler('pushVideoDetailPage', { itemJson: JSON.stringify(v), subject: 3 })
        },
        // 跳转所有考场
        goAllExam () {
            this.examRoomVisible = true
            this.allExamFlag = true
        },
        // 滚动事件
        scroll (v) {
            this.fixed = v.isFixed
        }
    },
    created () {
        this.examPlaceBatchId = this.initExamPlaceBatchId ? this.initExamPlaceBatchId : this.$route.query.examPlaceBatchId

        this.selectExamId = this.examPlaceBatchId
    },
    mounted () {
        this.goodsVideoListAll()
        this.goodsVideoList()
    }
}

</script>
<style scoped lang="scss">

.bg{
    width: 100%;
}
.c-exam-room-wrap{
    position: relative;

    .exam-room-wrap{
        z-index: 999999!important;
        background: #FFFFFF;
        border-radius: 10px 10px 0 0;
        .content-title{
            line-height: 1;
            position: relative;
            text-align: center;
            margin: 15px 0;
            .location{
                background: url("~@/assets/vipGoods/icon_dz.png") no-repeat left/13px;
                padding: 0 0 0 18px;
                position: absolute;
                left: 15px;
                top: 50%;
                transform: translateY(-50%);
                font-size: 12px;
                color: #000000;
            }
            .text{
                font-size: 18px;
                font-weight: 600;
                color: #000000;
                text-align: center;
            }
            .close{
                position: absolute;
                right: 15px;
                top: 50%;
                transform: translateY(-50%);
                width: 18px;
            }
        }
        .content{
            max-height: 400px;
            overflow: auto;
            -webkit-overflow-scrolling: touch;
            margin: 5px 0 0 0;
            padding: 0 20px;
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
            .photo{
                width: 100%;
                height: 100%;
            }
            .item{
                border: 2px solid #ffffff;
                position: relative;
                margin: 0 0 15px 0;
                width: 160px;
                height: 100px;
                border-radius: 5px;
                overflow: hidden;
                .info{
                    position: absolute;
                    left: 0;
                    top: 0;
                    flex-direction: column;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    width: 160px;
                    height: 100px;
                    background: rgba(0, 0, 0, 0.5);
                }
                .info b{
                    color: #FF5050;
                }
                .info .name{
                    font-size: 15px;
                    font-weight: 600;
                    color: #FFFFFF;
                }
                .info .num{
                    font-size: 12px;
                    color: #FFFFFF;
                }
            }
            .active{
                border: 2px solid #53CB85;
            }
            .active::after{
                width: 30px;
                height: 30px;
                position: absolute;
                right: -1px;
                bottom: -1px;
                content: ' ';
                background: url("~@/assets/vipGoods/icon_kcxz.png") no-repeat center/30px;
            }
        }
        .popup-footer{
            margin: 12px 0 0 0;
            padding: 0 20px;
            line-height: 18px;
            .msg{
                font-size: 12px;
                color: #999999;
            }
            .submit{
                margin: 20px 0;
                width: 335px;
                height: 45px;
                background: #53CB85;
                border-radius: 23px;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 18px;
                font-weight: 600;
                color: #FFFFFF;
            }
            .disabled{
                background: #CCCCCC;
            }
        }
    }
}
.video-wrap{
    bottom: 25px;
    left: 50%;
    transform: translateX(-50%);
    position: absolute;
    z-index: 2;
    margin: 0 auto;
    width: 325px;
    background: #FFFFFF;
    border-radius: 5px 0 0 5px;

    .video-header{
        position: relative;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 10px;

        .header-left{
            width: 80px;
            img{
                width: 24px;
            }
        }

        .title{
            flex: 1;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            font-weight: 600;
            font-size: 20px;
            color: #333333;
        }
        .btn-go-exam{
            display: flex;
            align-items: center;
            justify-content: center;
            width: 100px;
            height: 30px;
            border-radius: 28px;
            font-size: 14px;
            color: #FFFFFF;
            background: url('~@/assets/vipGoods/icon_qbkc.png') no-repeat;
            background-size: 100% 100%;
        }
        .tips{
            position: absolute;
            right: 0;
            bottom: 30px;
            padding: 6px 8px 11px 8px;
            line-height: 1;
            color: #FFFFFF;
            font-size: 12px;
            background: url('~@/assets/examVideoV2/icon_tcts02.png') no-repeat;
            background-size: 100% 100%;
        }
    }
    .video-category {
        margin-bottom: 15px;
        display: flex;
        white-space: nowrap;
        overflow: auto;
        -webkit-overflow-scrolling: touch;
        div{
            display: flex;
            align-items: center;
            justify-content: center;
            margin-right: 5px;
            width: 80px;
            height: 25px;
            color: #666;
            font-size: 14px;
            background-color: #F4F4F4;
            border: 1px solid #F4F4F4;
            border-radius: 5px;
            &.active{
                color: #FF6F04;
                border: 1px solid #FF6F04;
                background-color: #FEECDE;
            }
        }
    }
    .video-list{
        white-space: nowrap;
        overflow: auto;
        -webkit-overflow-scrolling: touch;
        &::-webkit-scrollbar {
            display: none;
        }

        .video-item{
            display: inline-block;
            margin: 0 15px 0 0;
            position: relative;
            width: 162px;
            height: 105px;
            border-radius: 6px;
            overflow: hidden;

            .mask{
                position: absolute;
                top:0;
                left:0;
                width: 100%;
                height: 100%;
                background-color:rgba(0,0,0,0.5);
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                color: #fff;
                .exam-place-name{
                    font-size: 19px;
                }
                .name{
                    margin-top: 15px;
                    font-size: 22px;
                    font-weight: 600;
                }
            }

            .cover{
                width: 100%;
                height: 100%;
                object-fit: cover;
            }
            .play{
                display: flex;
                align-items: center;
                justify-content: center;
                top: 0;
                width: 100%;
                height: 100%;
                position: absolute;
                background: rgba(0, 0, 0, 0.2);
                .van-icon{
                    font-size:26px;
                    color: #ffffff;
                }
            }

            .time{
                position: absolute;
                right: 5px;
                bottom: 5px;
                font-size: 16px;
                color: #FFFFFF;
            }
        }
        .video-item:last-child{
            margin: 0;
        }
    }

    &.top{
        position: static;
        left: 0;
        transform: translateX(0);
        width: 100%;
        padding: 0 0 15px 0;
        border-radius: 0;
        .video-category{
            padding: 0 15px;
        }
        .video-header{
            padding: 13px 10px 0;
        }
        .video-item{
            margin: 0 15px 0 0;
            height: 100px;
            width: 155px;
        }
        .video-list{
            margin: 0 auto;
            width: 345px;
        }
        .title{
            text-align: center;
            font-weight: 600;
            font-size: 18px;
        }

        .btn-go-exam{
            display: flex;
            align-items: center;
            justify-content: center;
            background: #fc893a;
            width: 80px;
            height: 24px;
            border-radius: 28px;
            font-size: 12px;
            color: #FFFFFF;
        }
        .tips{
            display: none;
        }
    }
}
</style>
